var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 12.95V8.38337L3.33333 6.06671V10.6334L7.33333 12.95ZM8.66667 12.95L12.6667 10.6334V6.06671L8.66667 8.38337V12.95ZM8 7.23337L11.95 4.95004L8 2.66671L4.05 4.95004L8 7.23337ZM2.66667 11.8C2.45556 11.6778 2.29167 11.5167 2.175 11.3167C2.05833 11.1167 2 10.8945 2 10.65V5.35004C2 5.1056 2.05833 4.88337 2.175 4.68337C2.29167 4.48337 2.45556 4.32226 2.66667 4.20004L7.33333 1.51671C7.54444 1.39449 7.76667 1.33337 8 1.33337C8.23333 1.33337 8.45556 1.39449 8.66667 1.51671L13.3333 4.20004C13.5444 4.32226 13.7083 4.48337 13.825 4.68337C13.9417 4.88337 14 5.1056 14 5.35004V10.65C14 10.8945 13.9417 11.1167 13.825 11.3167C13.7083 11.5167 13.5444 11.6778 13.3333 11.8L8.66667 14.4834C8.45556 14.6056 8.23333 14.6667 8 14.6667C7.76667 14.6667 7.54444 14.6056 7.33333 14.4834L2.66667 11.8Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForm);
export default __webpack_public_path__ + "static/media/icon-form.17936ceffd91825e770a1c372dc95b5b.svg";
export { ForwardRef as ReactComponent };